<template>
  <v-app>
    <Header />
    <SideBarMenu v-if="user_ex!=undefined && isAuthenticated" />    
    <v-main class="main-content">
      <v-container class="ma-0 pa-1 pt-11" max-width="100%">
        <Dialog v-if="isAuthenticated && vecti_user" />
        <Notification />
        <router-view :key="lastClickTime"></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { useAuth0 } from "@auth0/auth0-vue";
import { useSynchcronizeBank } from "./composables/useSynchronize";
import { useRouter } from "vue-router";
import LoadingMessage from "./components/welcome/LoadingMessage.vue";
import { time } from "echarts";

export default {
  data() {
    return {
      loading: true,
      //userExtended: "no user ext",
      //userExtended: "cargando",
    };
  },
  computed: {
    lastClickTime() {
      return store.state.lastClickTime;
    },
  },
  watch: {
    vecti_user(newUser) {
      this.checkConditions(newUser, this.isAuthenticated);
    },
    isAuthenticated(newAuth) {

      this.checkConditions(this.vecti_user, newAuth);
    },
    windowWidth(newWidth) {

      if (newWidth < 300) {
        store.commit("setWindowSize", "xs");

      } else if (newWidth < 500) {
        store.commit("setWindowSize", "sm");

      } else if (newWidth < 700) {
        store.commit("setWindowSize", "m");

      } else {
        store.commit("setWindowSize", "l");

      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    
    const route = useRoute();
    this.where = route.path;
    console.log("Mounted route: " + route.path);
    console.log("localStorage: " + JSON.stringify(localStorage));
    if (route.path === "/") {
      localStorage.removeItem("previousRoute");
    }
    

    this.windowFirstSize(window.innerWidth);

  },
  methods: {
    windowFirstSize(windowSize) {


      if (windowSize < 300) {
        store.commit("setWindowSize", "xs");

      } else if (windowSize < 500) {
        store.commit("setWindowSize", "sm");

      } else if (windowSize < 700) {
        store.commit("setWindowSize", "m");

      } else {
        store.commit("setWindowSize", "l");

      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    checkConditions(user, auth) {
      if (auth && user?.message === "Not Found") {

        this.loading = false;
        this.$router.push("/welcome");
      } else if (auth) {
        const previousRoute = localStorage.getItem("previousRoute");
        if (previousRoute) {

          this.$router.push(previousRoute);
          localStorage.removeItem("previousRoute");
        } else {

          this.$router.push("/start");
        }

      } else {
        setTimeout(() => {
          this.loading = false;
        }, 500);


      }
    },
  },
  setup() {
    let user_ex = null;
    let vecti_user = null;
    const { isAuthenticated } = useAuth0();
    const windowWidth = ref();
    const expand = ref(store.getters.getExpandMenu);
    const router = useRouter();
    console.log("isAuthenticated: " + isAuthenticated?.value);
    console.log("vecti_user: " + vecti_user?.value);
 const where= ref("");

    try {

      vecti_user = useUser();

      user_ex = useUserExtended(vecti_user, router);
    } catch (e) {
      console.log("Error en vecti_user: " + e);
    }

    const changeExpandMenu = () => {
      expand.value = !expand.value;
      store.commit("setExpandMenu", expand.value);
    };

    return {
      changeExpandMenu,
      expand,
      user_ex,
      vecti_user,
      isAuthenticated,
      windowWidth,
      where
    };
  },
};
</script>
